import Link from "next/link";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
// import { appData } from "../../data";
import { Parallax } from "react-parallax";
// import contactBG from "../../assets/images/contact.jpg";
import { FormattedMessage, useIntl } from "react-intl";

const Contact = ({ socialsData, contactUsBack }) => {
  const { locale } = useIntl();
  const neededInfo = socialsData?.filter((link) =>
    ["phone", "email", "location address", "location address_en"].includes(
      link?.socialType?.name?.en
    )
  );

  return (
    <>
      <Parallax bgImage={contactUsBack} strength={500} bgImageAlt="">
        <div className="contacts">
          <Container>
            <Row>
              <Col xl={6} lg={6} md={12} xs={12}>
                <h4
                // data-aos="fade-up"
                // data-aos-duration="300"
                // data-aos-delay="100"
                >
                  <FormattedMessage id="contactUs" />
                  <br />
                  <FormattedMessage id="now" />
                </h4>
              </Col>
              <Col xl={6} lg={6} md={12} xs={12}>
                <ul>
                  <li
                  // data-aos="fade-up"
                  // data-aos-duration="300"
                  // data-aos-delay={(index + 1) * 100}
                  >
                    <span>
                      <FormattedMessage id="phone" />
                    </span>
                    <p>
                      <Link
                        href={`tel:${
                          neededInfo?.filter(
                            (link) => link.socialType.name.en === "phone"
                          )[0]?.link
                        }`}
                      >
                        <a aria-label="go to phone">
                          {
                            neededInfo?.filter(
                              (link) => link.socialType.name.en === "phone"
                            )[0]?.link
                          }
                        </a>
                      </Link>
                    </p>
                  </li>
                  <li
                  // data-aos="fade-up"
                  // data-aos-duration="300"
                  // data-aos-delay={(index + 1) * 100}
                  >
                    <span>
                      <FormattedMessage id="email" />
                    </span>
                    <p>
                      <Link
                        href={`mailto:${
                          neededInfo?.filter(
                            (link) => link.socialType.name.en === "email"
                          )[0]?.link
                        }`}
                      >
                        <a aria-label="go to email">
                          {
                            neededInfo?.filter(
                              (link) => link.socialType.name.en === "email"
                            )[0]?.link
                          }
                        </a>
                      </Link>
                    </p>
                  </li>
                  <li
                  // data-aos="fade-up"
                  // data-aos-duration="300"
                  // data-aos-delay={(index + 1) * 100}
                  >
                    <span>
                      <FormattedMessage id="address" />
                    </span>
                    <p>
                      {
                        neededInfo?.filter(
                          (link) =>
                            link.socialType.name.en ===
                            `location address${locale === "ar" ? "" : "_en"}`
                        )[0]?.link
                      }
                    </p>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </Parallax>
    </>
  );
};

export default Contact;
